// extracted by mini-css-extract-plugin
export var backButtonBox = "ExperienceTemplate-module--backButtonBox--12db3";
export var backButtonWrapper = "ExperienceTemplate-module--backButtonWrapper--520f6";
export var cards = "ExperienceTemplate-module--cards--02d1e";
export var closeButton = "ExperienceTemplate-module--closeButton--334f3";
export var closeButtonBox = "ExperienceTemplate-module--closeButtonBox--954f4";
export var expertiseTitle = "ExperienceTemplate-module--expertiseTitle--fed04";
export var fullDisplayBox = "ExperienceTemplate-module--fullDisplayBox--ef799";
export var header = "ExperienceTemplate-module--header--9f1cf";
export var hide = "ExperienceTemplate-module--hide--247c6";
export var hover = "ExperienceTemplate-module--hover--fc41f";
export var indicator = "ExperienceTemplate-module--indicator--8c89b";
export var indicators = "ExperienceTemplate-module--indicators--8e36b";
export var mobileDock = "ExperienceTemplate-module--mobileDock--cb76e";
export var nextButton = "ExperienceTemplate-module--nextButton--ad857";
export var nextButtonBox = "ExperienceTemplate-module--nextButtonBox--9a528";
export var nextButtonText = "ExperienceTemplate-module--nextButtonText--e47b3";
export var prevButton = "ExperienceTemplate-module--prevButton--5dcff";
export var prevButtonBox = "ExperienceTemplate-module--prevButtonBox--6ba45";
export var prevButtonText = "ExperienceTemplate-module--prevButtonText--a6746";
export var text = "ExperienceTemplate-module--text--4c487";
export var title = "ExperienceTemplate-module--title--07602";
export var type = "ExperienceTemplate-module--type--01358";
export var visible = "ExperienceTemplate-module--visible--cc5ee";
export var wrapper = "ExperienceTemplate-module--wrapper--23521";